module.exports = __webpack_public_path__ + "img/title2.d0846236.png";